import { DiagnosticsActionType } from "models/actionTypes/diagnosticsActionType";
import { RootActionType } from "models/actionTypes/rootActionTypes";
import { DiagnosticsEnums } from "models/enums";
import { DiagnosticsState } from "models/stateTypes/diagnosticsState";
import { ReduxConstants } from "utils/constants";

const initialState: DiagnosticsState = {
  faqDiagnostics: {
    questions: [],
    visitedDefaultFAQArticle: false,
    sentSupportCase: false,
    importantActions: [],
    exitAction: undefined,
  },
};

export const diagnosticsReducer = (
  state: DiagnosticsState = initialState,
  action: DiagnosticsActionType | RootActionType
): DiagnosticsState => {
  switch (action.type) {
    case ReduxConstants.RootActions.RESET:
    case ReduxConstants.DiagnosticsActions.RESET_FAQ_DIAGNOSTICS:
      return initialState;
    case ReduxConstants.DiagnosticsActions.OPENED_DEFAULT_FAQ_ARTICLE:
      return {
        ...state,
        faqDiagnostics: {
          ...state.faqDiagnostics,
          visitedDefaultFAQArticle: true,
        },
      };
    case ReduxConstants.DiagnosticsActions.WROTE_QUESTION:
      return {
        ...state,
        faqDiagnostics: {
          ...state.faqDiagnostics,
          questions: [
            ...state.faqDiagnostics.questions,
            { query: action.payload, retrievedFAQArticleIds: [], visitedFAQArticleIds: [] },
          ],
        },
      };
    case ReduxConstants.DiagnosticsActions.RECEIVED_RETRIEVED_FAQ_ARTICLE:
      const lastQuestionReceivedAction = state.faqDiagnostics.questions[state.faqDiagnostics.questions.length - 1];
      lastQuestionReceivedAction.retrievedFAQArticleIds = action.payload;
      return {
        ...state,
        faqDiagnostics: {
          ...state.faqDiagnostics,
          questions: [...state.faqDiagnostics.questions.slice(0, -1), lastQuestionReceivedAction],
        },
      };
    case ReduxConstants.DiagnosticsActions.OPENED_RETRIEVED_FAQ_ARTICLE:
      const lastQuestionOpenedAction = state.faqDiagnostics.questions[state.faqDiagnostics.questions.length - 1];
      lastQuestionOpenedAction.visitedFAQArticleIds = [
        ...lastQuestionOpenedAction?.visitedFAQArticleIds,
        action.payload,
      ];
      return {
        ...state,
        faqDiagnostics: {
          ...state.faqDiagnostics,
          questions: [...state.faqDiagnostics.questions.slice(0, -1), lastQuestionOpenedAction],
        },
      };
    case ReduxConstants.DiagnosticsActions.CLICKED_CREATE_SUPPORT_CASE:
    case ReduxConstants.DiagnosticsActions.OPENED_CLOSE_CONFIRMATION:
      return {
        ...state,
        faqDiagnostics: {
          ...state.faqDiagnostics,
          importantActions: [...state.faqDiagnostics.importantActions, action.type],
        },
      };
    case ReduxConstants.DiagnosticsActions.CLOSED_DIALOG:
      return {
        ...state,
        faqDiagnostics: {
          ...state.faqDiagnostics,
          exitAction: DiagnosticsEnums.ExitAction.ClosedDialog,
        },
      };
    case ReduxConstants.DiagnosticsActions.SENT_SUPPORT_CASE:
      return {
        ...state,
        faqDiagnostics: {
          ...state.faqDiagnostics,
          sentSupportCase: true,
          exitAction: DiagnosticsEnums.ExitAction.SentSupportCase,
        },
      };
    default:
      return state;
  }
};
